// Vuejs application.
import '../app-vue/register'
